module.exports = __webpack_public_path__ + "static/media/nodoc-icon.aba85dd4.svg";